




























import Vue from 'vue';
import Component from 'vue-class-component';
import Task from './ItemTask.vue';
import ItemList from '../common/ItemList.vue';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import { Prop, Watch } from 'vue-property-decorator';
@Component({
    components: {
        Task,
        ItemList,
        FormNavigationButtons,
    },
})
export default class TicketAccessStepFour extends Vue {
    @Prop()
    oldTasks!: FORM_INTERFACE.tasksInterface[];

    @Prop({ default: {} })
    formValues!: {
        taskTypes: {
            value: number;
            text: string;
            description: string;
        }[];
    };
    isFormValid: boolean = true;
    $refs!: {
        form: any;
        list: any;
    };
    tasks: FORM_INTERFACE.tasksInterface[] = Array();

    sendData() {
        this.updateListData();
        return { tasks: this.tasks };
    }

    updateListData() {
        this.tasks = Array();
        this.$refs.list.requestData();
    }

    receiveData(data: any) {
        this.tasks.push(data);
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }

    @Watch('oldTasks')
    assignOldValues(
        value: FORM_INTERFACE.tasksInterface[],
        oldValue: FORM_INTERFACE.tasksInterface[],
    ) {
        if (oldValue.length == undefined) {
            this.$refs.list.setOldItems(this.oldTasks);
        }
    }
}
